module.exports = __webpack_public_path__ + "img/svg/separator.f84c18eceaf4662652da37e77f0d89b3.svg";